export default {
  title: 'Language',
  save_changes: 'Save changes',
};
